import AuthGenderRadioButtonComponent from "./AuthGenderRadioButtonComponent";

export default AuthGenderRadioButtonComponent;
